import { prixRemiseTotalProps, usePrixRemiseTotal } from "@/components/organisms/mixins/prix-remise-total.mixin";

export const productCategoryItemLightProps = () => ({
  rating: {
    type: Boolean,
    required: false,
    default: false
  },
  avantagesCalcules: {
    type: Boolean,
    required: false,
    default: false
  },
  cartContext: {
    type: String,
    required: false
  },
  isCommandeLdd: {
    type: Boolean,
    required: false,
    default: false
  },
  ...prixRemiseTotalProps()
})

export const useProductCategoryItemLight = (props) => {
  const { prixTotalRemise } = usePrixRemiseTotal(props);

  const isLdd = computed(() => {
    return props.article.type_panier === "ldd" || props.isCommandeLdd;
  })

  const badgeColor = (status) => {
    switch (status) {
      case "LIVRE":
        return "success";
      case "EN_ATTENTE":
        return "orange";
      case "EN_COURS":
        return "orange";
      case "ANNULE":
        return "warning";
      default:
        return "orange";
    }
  }

  return {
    prixTotalRemise,
    isLdd,
    badgeColor
  }
}